import React from 'react';
import RecentGameList from './sub/RecentGameList';
import { useTranslation } from 'react-i18next';
import ballImage from '../../assets/img/icon/ball_icon.png';

function RecentGameMain(props) {
    let playerObj = props['profile'];
    const { t } = useTranslation();

    return (
        <>
            <div className="boxTitle">
                <img src={ballImage} style={{height:'25px'}} alt='#'/> {t('Last10G')}
            </div>
            <div className="recordTable">
                <RecentGameList profile={playerObj}/>
            </div>
        </>
    )
}

export default RecentGameMain;